// extracted by mini-css-extract-plugin
module.exports = {"Separator":"styles_Separator__bdnE6"};